<template>
  <modal
    v-if="logNode"
    title="Log Modal"
    ref="modal"
    id="agLogModal"
    class="modal-container"
    name="logModal"
    width="1114px"
    height="85%"
    :draggable=true
    :resizable=true
    :adaptive=true
    :scrollable=true
    :shiftX=.5
    :shiftY=0
    styles="display:flex; flex-direction:column;padding:15px;"
    drag="drag"
    content-class="modal-content"
    resize="resize"
    :fit-parent="true"
    :resize-directions="['br']"
    :clickToClose="false"
    :escToClose="true"
    @keyup.enter.native="saveButton_click"
  >
    <div>
      <h4 v-if="disableUI" class="agModal-title">View Log Node</h4>
      <h4 v-else class="agModal-title">Edit Log Node</h4>
      <hr/>
    </div>
    <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
    <div class="agInputGroup agInputGroupCentered">
        <label>Source(s):</label>
        <b-input type="text" :value="srcStr" autocomplete="false" disabled></b-input>
      </div>
      <b-input-group size="md" prepend="Name">
        <b-input type="text" v-model="logNode.name" autocomplete="false" :disabled="disableUI"></b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input type="text" v-model="logNode.description" autocomplete="false" :disabled="disableUI"></b-input>
      </b-input-group>
      <hr>
      <div class="agInputGroup">
        <center>
        <label>Inputs/Outputs:</label>
        </center>
        <div style="display:flex; margin-left:30%;" class="agInputGroup agInputGroupCentered">
        <div>
        <select style="font-family: inherit; border-radius:4px; height:120%; font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif;" required v-on:click="onChange($event)" id="agLogNodeModal-multiSelect" name="nodes" multiple>
        <option style="
          display: block;
          padding: 0px 14px 1px;
          color: #495057;
        " v-for="t in objectOptions" :selected="t.selected" v-bind:value="t.value" :key="t.name">{{t.text}}</option>
        </select>
          </div>
          <label id="agLogNodeModal-multiSelectLabel"><i>Hold<br>ctl or command to<br>multi-select/deselect</i></label>      
        </div>
        <div class="agInputGroup agInputSubGroup">
          <label id="agLogNodeModal-selectedLabel" >Selected: {{selectedStr}}</label>
        </div>
      </div>
      <hr>
      <div class="agInputGroup agInputGroupCentered">
        <input 
          type="checkbox" 
          v-model="logNode.enabled"
          :disabled="disableUI"/>
        <label>Enabled</label>
      </div>
      <hr>
      <div class="agInputGroup agInputGroupCentered">
        <label>Destination:</label>
        <b-input type="text" v-model="destName" autocomplete="false" disabled></b-input>
      </div>
      <div v-if="modalMessage">
        <hr>
        <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
      </div>
   </div>
   <div>
    <hr/>
    <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
    <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
    <b-button
      class="agModal-buttonRight"
      variant="danger"
      :disabled="disableUI || isLoading"
      @click="deleteButton_click"
      style="margin-left:82%;"
      >Delete</b-button
    >
    <b-button
      class="agModal-buttonRight"
      variant="primary"
      :disabled="disableUI || isLoading"
      @click="saveButton_click"
      style="float:right;"
      >Save</b-button>
   
   </div>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      id="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click"
    >
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Log Node</h4>
      </template>
      Are you sure you want to delete log node
      <i>{{ name }}</i
      >?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click"
          >Delete</b-button
        >
      </template>
    </b-modal>
  </modal>
</template>

<script>
// modules
import _ from "lodash";
// components

export default {
  name: "ag-logNode-modal",
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },
  data() {
    return {
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      objectOptions: [],
    };
  },
  computed: {
    
    logNode() {
      if(this.node && this.node.type == "logNode")
        return this.node.object;
      return null;
    },

   name() {
      if(this.logNode.name)
      {
        return this.logNode.name;
      }
      return this.logNode.shortname;
    },

  srcStr() {
    if(!this.logNode.src || this.logNode.src.length == 0)
    return "";

  var srcStr = "";
  for(var i = 0; i < this.logNode.src.length; i++)
  {
    var src = this.logNode.src[i];
    srcStr += src.shortname + ", ";
  }
  srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last , 
  return srcStr;
  },

  destName() {
    if(this.logNode.dest)
      return this.logNode.dest.shortname;
    return "";
  },
      selectedStr() {
        if(this.logNode.logObjects.length > 0) {
          var selectedStr = "";
          for(var i = 0; i < this.logNode.logObjects.length; i++) {
            var object = this.logNode.logObjects[i];
            selectedStr += object + ", ";
          }
          selectedStr = selectedStr.substring(0, selectedStr.length - 2);
          return selectedStr;
        }
        return "";
      },
  },

  mounted() {},

  methods: {
    // UI Events
    onChange(e) {
    let result =[];
    const selected = document.querySelectorAll('#agLogNodeModal-multiSelect');
    for(let i =0; i < selected[0].length; i++) {
      if(selected[0][i].selected){
        result.push(selected[0][i].value);
      }
    }
    return this.logNode.logObjects = result;
    },
    selectedOptions() {
      //this code will preserve the original order of the array
      let result =[];
      const selected = this.logNode.logObjects;
      for(let i =0; i<this.objectOptions.length; i++) {
        if(selected.includes(this.objectOptions[i].value)){
          result.push({text:this.objectOptions[i].text, value:this.objectOptions[i].value, selected:true});
        }else{
          result.push(this.objectOptions[i]);
        }
      }
      return this.objectOptions = result;
      
    },
    cancelButton_click() {
      this.$modal.hide('logModal');
    },

    async saveButton_click() {

      this.modalMessage = "";

      const node = {
        object: this.logNode,
        type: "logNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {node: node});
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "logNode",
          object: result.data.node
        };
        this.hide();
        this.hide();
        this.$emit("updatedNode", updated);
      } 
      else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.logNode,
        type: "logNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {node: node});
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();    
    },

    // other
    show() {
      setTimeout(() => {
        this.reset();
        this.selectedOptions();
        this.$modal.show('logModal',{ draggable: true });
      }, 250);
    },

    hide() {
      this.$modal.hide('logModal');
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      this.setObjectOptions();
  },

  setObjectOptions() {
    this.objectOptions = [];
    let result =[];
  
    var nodeTypes = this.$store.getters["nodeStore/getInputAndOutputTypes"];
    for(var i = 0; i < nodeTypes.length; i++) {
      var nodeType = nodeTypes[i];
      if(!nodeType.plural)
        continue;
      var nodes = this.workflow[nodeType.plural];
      for(var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        var name = node.shortname;
        if(node.name)
          name += `: ${node.name}`;

        var option = {value: node.shortname, text: name};
        this.objectOptions.push(option);
      }
    }
  }
  }
};
</script>

<style scoped lang="css">

#agLogNodeModal-multiSelect {
  width: 500px;
}

#agLogNodeModal-multiSelectLabel {
  margin-left: 15px;
  vertical-align: middle;
  font-size: 14px;
}

#agLogNodeModal-selectedLabel {
  margin-left: 115px;
}
</style>


// WEBPACK FOOTER //
// src/components/nodes/LogNodeModal.vue